import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from "./pages/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
